  export enum EnumLabRange
  {
    ActionLevel="Action",
    AcceptableLevel="Acceptable",
    UnacceptableLevel="Unacceptable"
  }
     